import {Answer} from './answer';

export class Question {
  constructor(
    public id: string,
    public position: number,
    public text: string,
    public answer: Answer) {}
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/question.ts